module.exports = __webpack_public_path__ + "img/books-medical.5137e3f1.svg";